import React, { forwardRef, useState, useEffect, useRef } from 'react'
import { Global } from '@emotion/react'
import { remove as removeArr, findIndex } from 'lodash-es'
import { Button, Toast } from '@ow/comps'
import { avaliableGeoInfoFilter } from '@ow/utils'
import locationImg from './assets/location.png'
import Search from './Search'
import GeoList from './List'
import useMap from './use-map'
import { styles } from './styles'

const transformJeoJson = (value) => {
  const features = avaliableGeoInfoFilter(value).map((v) => {
    return { geometry: v, type: 'Feature' }
  })
  return { features, type: 'FeatureCollection' }
}

const remove = (arr, index) => {
  return removeArr(arr, (v, i) => {
    return i !== index
  })
}
// const insert = (arr, index, v) => {
//   const arr1 = slice(arr, 0, index)
//   const arr2 = slice(arr, index, arr.length)
//   return [...arr1, v, ...arr2]
// }
const append = (arr, v) => {
  return [...arr, v]
}

const getPositionByLngLat = (lnglat) => {
  if (!lnglat) return null
  const { lng, lat } = lnglat
  return [lng, lat]
}

const Render = function (
  { opts = {}, value = [], onChange, formControl },
  ref
) {
  const { maxArea } = opts
  const { setValue } = formControl
  const { slug } = opts
  const geosRef = useRef()
  const selectedGeos = useRef([])
  const optType = useRef()

  const currentEditPolygon = useRef([]) // 用户处理区域编辑时保存编辑前的区域path
  const isResetRegion = useRef(false) // 是否恢复区域编辑

  const [locationName, setLocationName] = useState('')
  // 编辑状态
  const [isEditRegion, setIsEditRegion] = useState(false)
  // 当前选中的覆盖物
  const [currentGeoIndex, setCurrentGeoIndex] = useState(null)
  // 当前选中的覆盖物的序号
  const [currentIndex, setCurrentIndex] = useState(null)

  const {
    init,
    amap,
    AMap,
    getGeocoder,
    setCenter,
    drawPolygon,
    closeRegionEdit,
    defaultMarkerContent,
    activeMarkerContent,
    addPolygonMultipleEvents,
    showJeojson,
  } = useMap(slug)

  const onSelectedGeosChange = () => {
    if (onChange) {
      const areas = []
      const arr = selectedGeos.current
        .map((v) => {
          if (v.path) {
            const coordinates = []
            const lnglats = v.path.flat(Infinity).map((p) => {
              const { lat, lng } = p
              areas.push([lng, lat])
              return [lng, lat]
            })

            coordinates.push([lnglats])
            return { coordinates, type: 'Polygon' }
          }
          if (v.position) {
            return { coordinates: v.position, type: 'Point' }
          }
          return null
        })
        .filter((v) => v)
      const currentArea = Math.round(AMap.GeometryUtil.ringArea(areas))
      console.log('areas', currentArea)
      const polygon = arr.filter((a) => {
        return a.type === 'Polygon'
      })
      const point = arr.filter((a) => {
        return a.type === 'Point'
      })
      if (maxArea && currentArea !== 0) {
        const max = maxArea + maxArea * 0.05
        const min = maxArea - maxArea * 0.05
        if (currentArea > max || currentArea < min) {
          Toast.error({
            title: '绘制的面积和占地面积误差5%',
          })
        } else {
          setValue('mgeom', polygon)
          onChange(point)
        }
      } else {
        setValue('mgeom', polygon)
        onChange(arr)
      }
    }
  }

  // 更新当前选中覆盖物
  const updateCurrentGeo = (v) => {
    selectedGeos.current.forEach((item, num) => {
      if (item._amap_id === v._amap_id) {
        setCurrentGeoIndex({
          geo: item.geo,
          index: num + 1,
          mapid: v._amap_id,
        })
        if (item.position) {
          setCenter(item.position)
        } else if (v.getPath) {
          const { lng, lat } =
            v.getPath().slice() &&
            v.getPath().slice().length &&
            v.getPath().slice()[0]
          setCenter([lng, lat])
        }

        setCurrentIndex(num + 1)
        const { CLASS_NAME } = v
        currentEditPolygon.current =
          CLASS_NAME === 'AMap.Marker' ? [] : v.getPath().slice()
      }
    })
  }

  // 点击事件
  const clickEvent = (v, i) => {
    return () => {
      amap.clearEvents('click')
      // v.setContent(`<div class="custom-content-marker">
      // <img class="custom-icon" src=${locationImg} />
      // <span class="marker-active-num">${i}</span>
      // </div>`)
      setCurrentGeoIndex({ geo: v, index: i, mapid: v._amap_id })
      setCurrentIndex(i)
      v.on('click', () => {})
    }
  }

  // 更新覆盖物序号
  const updateGeosIndex = () => {
    const overlays = amap.getAllOverlays()
    overlays.forEach((v) => {
      const { CLASS_NAME, _amap_id } = v

      const currentOverlayIndex = findIndex(selectedGeos.current, (s) => {
        return s._amap_id === _amap_id
      })
      // 暂时只marker显示了序号
      if (CLASS_NAME === 'AMap.Marker') {
        v.setContent(defaultMarkerContent(currentOverlayIndex + 1))
        v.on('click', clickEvent(v, currentOverlayIndex + 1))
      }
    })
  }

  // 更新某一覆盖物地址（eg:拖拽、区域编辑后的处理）
  const updateGeoAddress = (e, address) => {
    const { CLASS_NAME } = e
    amap.getAllOverlays().forEach((item) => {
      if (!isResetRegion.current && item._amap_id === e._amap_id) {
        isResetRegion.current = false
        selectedGeos.current = selectedGeos.current.map((s) => {
          if (s._amap_id === item._amap_id) {
            return {
              geo: e,
              address,
              _amap_id: s._amap_id,
              path: CLASS_NAME === 'AMap.Marker' ? null : e.getPath().slice(),
            }
          }
          return s
        })

        onSelectedGeosChange()
      } else if (item._amap_id === e._amap_id) {
        isResetRegion.current = false
        // 区域编辑取消
        const geos = geosRef.current.returnFileds()
        geos.forEach((filed) => {
          const { geo } = filed
          if (geo._amap_id === e._amap_id) {
            e.setPath(currentEditPolygon.current)
          }
        })
      }
    })
  }

  // 覆盖物完成拖动事件
  const dragendEvent = (e) => {
    e.on('dragend', (v) => {
      getGeocoder().getAddress(v.lnglat, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          const address = result.regeocode.formattedAddress
          // 拖动后更新地址
          const { CLASS_NAME, _amap_id } = e

          selectedGeos.current = selectedGeos.current.map((s) => {
            if (s._amap_id === _amap_id) {
              return {
                geo: e,
                address,
                _amap_id,
                path: CLASS_NAME === 'AMap.Marker' ? null : e.getPath().slice(),
                position:
                  CLASS_NAME === 'AMap.Marker'
                    ? getPositionByLngLat(v.lnglat)
                    : null,
              }
            }
            return s
          })

          onSelectedGeosChange()
        }
      })
    })
  }

  // 添加绘制区域事件
  const addPolygonEvent = (Polygon, lnglat, isUpdate) => {
    if (!lnglat) return
    getGeocoder().getAddress(lnglat, (status, result) => {
      if (status === 'complete' && result.regeocode) {
        const address = result.regeocode.formattedAddress
        if (isUpdate) {
          updateGeoAddress(Polygon, address)
        } else {
          selectedGeos.current = append(selectedGeos.current, {
            geo: Polygon,
            address,
            _amap_id: Polygon._amap_id,
            path: Polygon.getPath().slice(),
            position: null,
          })
          onSelectedGeosChange()
        }
      }
    })
  }

  const addMarkerMultipleEvents = (marker, { lnglat, index }) => {
    // 添加选中（点击）事件
    marker.on('click', clickEvent(marker, index))
    // amap.add(marker)
    // amap.setFitView()
    let address = null
    getGeocoder().getAddress(lnglat, (status, result) => {
      if (status === 'complete' && result.regeocode) {
        address = result.regeocode.formattedAddress
        selectedGeos.current = append(selectedGeos.current, {
          geo: marker,
          address,
          _amap_id: marker._amap_id,
          path: null,
          position: lnglat,
        })
        setCurrentGeoIndex({
          geo: marker,
          index,
          mapid: marker._amap_id,
        })
        setCurrentIndex(index)
        onSelectedGeosChange()
      }
    })
    // 拖拽事件
    dragendEvent(marker)
    // // 添加选中（点击）事件
    // marker.on('click', clickEvent(marker, index))
    // amap.add(marker)
    // amap.setFitView()
    // let address = null
    // getGeocoder().getAddress(
    //   defaultMarkerShow ? marker.w.position : lnglat || location,
    //   (status, result) => {
    //     if (status === 'complete' && result.regeocode) {
    //       address = result.regeocode.formattedAddress
    //       selectedGeos.current = append(selectedGeos.current, {
    //         geo: marker,
    //         address,
    //         _amap_id: marker._amap_id,
    //         path: null,
    //         position: [lng, lat],
    //       })
    //       setCurrentGeoIndex({
    //         geo: marker,
    //         index,
    //         mapid: marker._amap_id,
    //       })
    //       setCurrentIndex(index)
    //       onSelectedGeosChange()
    //     }
    //   }
    // )
    // // 拖拽事件
    // dragendEvent(marker)
  }

  // 选点事件
  const addMarkerEvent = (e, isSearch) => {
    if (optType.current === 'marker' || isSearch) {
      const index = amap.getAllOverlays().length + 1
      // location
      const { lnglat } = e
      const { lng, lat } = lnglat
      // let lng
      // let lat
      // if (!defaultMarkerShow) {
      //   lng = lnglat ? lnglat.getLng() : location.getLng()
      //   lat = lnglat ? lnglat.getLat() : location.getLat()
      // } else {
      //   lng = lnglat.lng
      //   lat = lnglat.lat
      // }
      // 只有选中后才能拖拽（刚添加的点位是选中状态）
      const options = {
        position: [lng, lat],
        content: activeMarkerContent(index),
        draggable: true,
        cursor: 'move',
      }
      const marker = new AMap.Marker(options)
      addMarkerMultipleEvents(marker, { lnglat: [lng, lat] })
      amap.add(marker)
      amap.setFitView()
    }
  }

  // 删除某一覆盖物
  const deleteGeo = (v) => {
    const { geo } = v
    if (geo) {
      amap.remove(geo)

      selectedGeos.current = remove(selectedGeos.current, v.index - 1)
      setCurrentGeoIndex(null)
      setCurrentIndex(null)
      updateGeosIndex()
      onSelectedGeosChange()
    }
  }

  // 选中后的处理，更新序号
  useEffect(() => {
    if (currentIndex) {
      const { geo, mapid } = currentGeoIndex
      if (geo.CLASS_NAME === 'AMap.Marker') {
        geo.setDraggable(true)
      } else {
        const options = geo.getOptions()
        geo.setOptions({ ...options, draggable: true })
      }
      const overlays = amap.getAllOverlays()

      overlays.forEach((v) => {
        const { _amap_id } = v

        const currentOverlayIndex = findIndex(selectedGeos.current, (s) => {
          return s._amap_id === _amap_id
        })

        const { CLASS_NAME } = v
        if (CLASS_NAME === 'AMap.Marker') {
          // 点
          if (currentOverlayIndex + 1 !== currentIndex) {
            v.setContent(defaultMarkerContent(currentOverlayIndex + 1))
            v.on('click', clickEvent(v, currentOverlayIndex + 1))
          } else {
            v.setContent(`<div class="custom-content-marker">
          <img class="custom-icon" src=${locationImg} />
          <span class="marker-active-num">${currentOverlayIndex + 1}</span>
          </div>`)
            v.off('click', clickEvent)
          }
          if (mapid !== v._amap_id) {
            v.setDraggable(false)
          }
        } else {
          // 区域
          const options = v.getOptions()
          if (mapid !== v._amap_id) {
            v.setOptions({
              ...options,
              draggable: false,
              fillColor: 'white',
              fillOpacity: 0,
              strokeOpacity: 0.8,
            })
          } else {
            v.setOptions({
              ...options,
              draggable: true,
              fillColor: '#0056fe',
              fillOpacity: 0.5,
              strokeOpacity: 1,
            })
          }
        }
      })
    }
  }, [currentIndex])

  useEffect(() => {
    init('normal')
  }, [])

  useEffect(() => {
    if (amap && value) {
      // 回显
      showJeojson(transformJeoJson(value), {
        polygonEvents: (polygon, lnglats) => {
          addPolygonMultipleEvents(polygon, {
            path: lnglats[0][0]
              .filter((d) => d && d.every((v) => v))
              .map((d) => {
                return new AMap.LngLat(d[0], d[1])
              }),
            event: setIsEditRegion,
            dragEvent: dragendEvent,
            addPolygonEvent,
            updateCurrentGeo,
          })
        },
        markerEvents: (marker, coordinates) => {
          addMarkerMultipleEvents(marker, { lnglat: coordinates })
        },
      })

      amap.setFitView()
    }
  }, [amap])

  return (
    <>
      <Global styles={styles} />
      <div className="w-full mt-2 relative" ref={ref}>
        <div
          className="flex flex-row items-center justify-between mb-2"
          style={{ zIndex: '1000' }}
        >
          <div className="flex flex-row items-center gap-2">
            <Button
              size="sm"
              type="primary"
              onClick={() => {
                amap.clearEvents('click')
                optType.current = 'marker'
                amap.on('click', (e) => {
                  addMarkerEvent(e, false)
                })
              }}
            >
              绘制点
            </Button>
            <Button
              size="sm"
              type="primary"
              onClick={() => {
                amap.clearEvents('click')
                optType.current = 'polygon'
                drawPolygon(
                  setIsEditRegion,
                  dragendEvent,
                  addPolygonEvent,
                  updateCurrentGeo
                )
              }}
            >
              绘制区域
            </Button>
          </div>

          {isEditRegion && (
            <div className="flex flex-row items-center gap-2">
              <Button
                size="sm"
                onClick={() => {
                  isResetRegion.current = true
                  closeRegionEdit()
                }}
              >
                恢复
              </Button>
              <Button size="sm" onClick={closeRegionEdit}>
                保存
              </Button>
            </div>
          )}
        </div>
        <div className="w-full flex flex-row items-center justify-between">
          <GeoList
            geos={selectedGeos.current}
            currentGeoIndex={currentGeoIndex}
            updateCurrentGeo={updateCurrentGeo}
            deleteGeo={deleteGeo}
            geosRef={geosRef}
          />
          <div
            className="relative"
            style={{
              width: 'calc(100% - 1.75rem)',
              height: '25rem',
              borderRadius: '0.1rem',
            }}
            id={slug}
          >
            {amap && (
              <Search
                keyword={`${slug}-keyword`}
                amap={amap}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                AMap={AMap}
                setCenter={setCenter}
                locationName={locationName}
                updateLocationName={setLocationName}
                addMarkerEvent={addMarkerEvent}
                dragendEvent={dragendEvent}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default forwardRef(Render)
